module.exports = __webpack_public_path__ + "static/media/Vuilniswagen.f8187645.mp3";